import "./Heromoduleoneimage.css";
const Heromoduleoneimage = (props) => {
  return (
    <>
      <div className="container-fluid heromodulecontainer">
        <img src="/images/contactus.jpg" className="hero-one-img" />
        <div className="heromodule-caption w-50"></div>
      </div>
    </>
  );
};

export default Heromoduleoneimage;
